import React from 'react';
import PropTypes from 'prop-types';
import FilterListIcon from '@mui/icons-material/FilterList';
import { IconButton, Tooltip } from '@mui/material';
import Container from './styles/Container';

function AdvicesToolbarWidget({ toogleFilters }) {
  return (
    <Container>
      <Tooltip title="Фильтры">
        <IconButton onClick={toogleFilters}>
          <FilterListIcon />
        </IconButton>
      </Tooltip>
    </Container>
  );
}

AdvicesToolbarWidget.propTypes = {
  toogleFilters: PropTypes.func.isRequired,
};

export default AdvicesToolbarWidget;
